import { ReactElement } from 'react';

/** Ícones de traço do design da tela do Modo Eco simplificado (mesmos desenhos do protótipo). */
interface IconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
}

function StrokeIcon({
  size = 18, color = 'currentColor', strokeWidth = 2, className, children,
}: Readonly<IconProps & { children: ReactElement | ReactElement[] }>): ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={className}
    >
      {children}
    </svg>
  );
}

export function ChevronDownIcon(props: Readonly<IconProps>): ReactElement {
  return <StrokeIcon {...props}><path d="M6 9l6 6 6-6" /></StrokeIcon>;
}

export function ChevronUpIcon(props: Readonly<IconProps>): ReactElement {
  return <StrokeIcon {...props}><path d="M18 15l-6-6-6 6" /></StrokeIcon>;
}

export function CheckIcon(props: Readonly<IconProps>): ReactElement {
  return <StrokeIcon {...props}><path d="M20 6L9 17l-5-5" /></StrokeIcon>;
}

export function PlusIcon(props: Readonly<IconProps>): ReactElement {
  return <StrokeIcon {...props}><path d="M12 5v14M5 12h14" /></StrokeIcon>;
}

export function MinusIcon(props: Readonly<IconProps>): ReactElement {
  return <StrokeIcon {...props}><path d="M5 12h14" /></StrokeIcon>;
}

export function PencilIcon(props: Readonly<IconProps>): ReactElement {
  return (
    <StrokeIcon {...props}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z" />
    </StrokeIcon>
  );
}

export function TrashIcon(props: Readonly<IconProps>): ReactElement {
  return <StrokeIcon {...props}><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /></StrokeIcon>;
}

export function GlobeIcon(props: Readonly<IconProps>): ReactElement {
  return (
    <StrokeIcon {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3c2.5 2.7 2.5 15.3 0 18M12 3c-2.5 2.7-2.5 15.3 0 18" />
    </StrokeIcon>
  );
}

export function GearIcon(props: Readonly<IconProps>): ReactElement {
  return (
    <StrokeIcon {...props}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </StrokeIcon>
  );
}

export function ExternalArrowIcon(props: Readonly<IconProps>): ReactElement {
  return <StrokeIcon {...props}><path d="M7 17L17 7M9 7h8v8" /></StrokeIcon>;
}

export function SaveIcon(props: Readonly<IconProps>): ReactElement {
  return (
    <StrokeIcon {...props}>
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <path d="M17 21v-8H7v8M7 3v5h8" />
    </StrokeIcon>
  );
}

export function DownloadIcon(props: Readonly<IconProps>): ReactElement {
  return <StrokeIcon {...props}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" /></StrokeIcon>;
}
